import React, { useEffect } from "react";

import HeroSlider from "../components/UI/HeroSlider";
import Helmet from "../components/Helmet/Helmet";

import { Container, Row, Col } from "reactstrap";
import AboutSection from "../components/UI/AboutSection";
import BookingForm from "../components/UI/BookingForm";
import ServicesList from "../components/UI/ServicesList";
import Testimonial from "../components/UI/Testimonial";
// import CommonSection from "../components/UI/CommonSection";

import AOS from 'aos';
import "aos/dist/aos.css"
import "../styles/home.css";


const Home = () => {
  useEffect(()=>{
    AOS.init({duration: 800});
  },[]);
  return (
    <Helmet title="Home">
      {/* ============= hero section =========== */}
      <section className="p-0 hero__slider-section">
        <HeroSlider />
      </section>
      {/* =========== about section ================ */}
      <AboutSection />

      {/* ==========Form Section=========== */}
      <section id="hero_form" style={{height: 0, padding: 0}}></section>
      <section className="booking__section mt-5" data-aos="fade-up">
        <div className="hero__form">
          <Container>
            <Row className="form__row">
              <div className="find__cars-left text-center w-100 mb-4">
                <h6 className="section__subtitle">Book Ride</h6>
                <h2 className="section__title">Travel With Kim Cab</h2>
              </div>
              <BookingForm />
            </Row>
          </Container>
        </div>
      </section>

      {/* ========== services section ============ */}
      <section
        id="services"
        className="services__section mt-5"
        data-aos="fade-up"
      >
        <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle">See our</h6>
              <h2 className="section__title">Popular Services</h2>
            </Col>

            <ServicesList />
          </Row>
        </Container>
      </section>

      {/* =========== testimonial section =========== */}
      <section className="testimonial__section mt-5">
        <Container>
          <Row>
            <Col lg="12" className="mb-4 text-center">
              <h6 className="section__subtitle">Our clients says</h6>
              <h2 className="section__title">Testimonials</h2>
            </Col>

            <Testimonial />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Home;
